<template>
    <div class="labelpopup" v-if="dataVal.flag">
        <div class="label">
            <div class="label_head">
                <div class="label_head_close"></div>
                <div class="label_head_title">标签</div>
                <div class="label_head_close" @click="handleRefund">
                    <i class="el-icon-close"></i>
                </div>
            </div>
            <div class="label_tab">
                <div class="label_tab_t">
                    <div class="label_tab_t_l">添加标签：</div>
                    <div class="label_tab_t_r ">
                        <div class="label_tab_t_r_add flexcenter" @click="Addlabel">点击添加</div>
                        <div class="label_tab_t_r_list">
                            <div class="label_tab_t_r_item flexcenter" v-for="(item, index) in labellist" :key="index">
                                <el-input v-model="item.label" placeholder="" v-if="item.status"></el-input>
                                <div v-else>{{ item.label }}</div>
                                <img src="@/assets/images/edit.png" alt="" srcset="" @click="Editlabel(item.label)">
                                <img src="@/assets/images/close.png" alt="" srcset="" @click="removelabel(index)">
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="label_btn">
                <div class=" label_btn_cancel" @click="handleRefund">取消</div>
                <div class="label_btn_cancel label_btn_submit" @click="handleSubmit">提交</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AddLabel",
    props: ['dataVal'],
    data() {
        return {
            labellist: []
        }
    },
    methods: {
        Addlabel() {
            this.labellist.forEach(item => {
                if (item.label) {
                    item.status = false
                }
            })
            this.labellist.push({
                status: true,
                label: ''
            })
        },
        Editlabel(label) {
            this.labellist.forEach(item => {
                if (item.label == label) {
                    item.status = true
                }
            })
        },
        removelabel(index) {
            if (this.labellist.length == 1) {
                this.$message.error('至少保留一个标签');
                return false
            }
            this.labellist.forEach(item => {
                if (item.label) {
                    item.status = false
                }
            })
            this.labellist.splice(index, 1)
        },
        //取消弹窗
        handleRefund() {
            let data = {
                flag: false,
                submitFlag: false
            }
            this.$emit("addlabelCal", data);
        },
        handleSubmit() {
            this.labellist = this.labellist.filter(item => item.label)
            if (this.labellist.length == 0) {
                this.$message.error('至少保留一个标签');
                return false
            }
            let labelarr = []
            this.labellist.forEach(item => {
                labelarr.push(item.label)
            })

            console.log(labelarr);
            let obj = {
                flag: false,//弹窗是否显示
                submitFlag: true,//是否调用接口
                labellist: labelarr
            }
            this.$emit("addlabelCal", obj);
        },
    },
    watch: {
        dataVal: {
            handler(newVal, oldVal) {
                if (newVal.flag) {
                    this.labellist = []
                    newVal.labellist.forEach(item => {
                        this.labellist.push({
                            status: false,
                            label: item
                        })
                    });
                }
            },
            deep: true
        }
    }
}
</script>

<style scoped lang="scss">
.labelpopup {
    width: 100vw;
    height: 100vh;
    background-color: rgba($color: #000000, $alpha: 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9;

    .label {
        min-width: 580px;
        background-color: #fff;
        border-radius: 16px;
        overflow: hidden;
        display: flex;
        flex-direction: column;

        .label_head {
            width: 100%;
            height: 50px;
            background-color: #f6f6f6;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 20px;

            .label_head_close {
                width: 20px;
                height: 20px;
                cursor: pointer;

                .el-icon-close {
                    font-size: 20px;
                    color: #999999;
                    cursor: pointer;
                }
            }

            .label_head_title {
                font-size: 16px;
                color: #333333;
                cursor: default;
            }
        }

        .label_tab {
            width: 100%;
            display: flex;
            flex-direction: column;
            padding: 30px;
            padding-right: 20px;

            .label_tab_t {
                width: 100%;
                display: flex;

                .label_tab_t_l {
                    font-size: 14px;
                    letter-spacing: 1px;
                    color: #333333;
                }

                .label_tab_t_r {
                    max-width: 440px;
                    display: flex;
                    flex-direction: column;
                    margin-left: 10px;

                    .label_tab_t_r_add {
                        width: 100px;
                        height: 32px;
                        font-size: 14px;
                        color: #606266;
                        background-color: #ffffff;
                        border-radius: 4px;
                        border: solid 1px #dbdbdb;
                        cursor: pointer;
                    }

                    .label_tab_t_r_list {
                        width: 100%;
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                        margin-top: 10px;

                        .label_tab_t_r_item {
                            width: 100px;
                            height: 32px;
                            background-color: #ffffff;
                            border-radius: 4px;
                            border: solid 1px #dbdbdb;
                            display: flex;
                            align-items: center;
                            justify-content: space-evenly;
                            margin-right: 10px;
                            margin-top: 10px;

                            /deep/.el-input {
                                width: 40px;
                                height: 100%;

                                .el-input__inner {
                                    height: 100%;
                                    line-height: auto;
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                }
                            }

                            div {
                                font-size: 14px;
                                color: #606266;
                            }

                            img {
                                width: 11px;
                                height: 11px;
                                cursor: pointer;
                            }
                        }
                    }
                }
            }
        }

        .label_btn {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            padding: 30px 37px 26px 37px;

            .label_btn_cancel {
                width: 80px;
                height: 32px;
                font-size: 14px;
                color: #606266;
                background-color: #ffffff;
                border-radius: 4px;
                border: solid 1px #dbdbdb;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-left: 10px;
                cursor: pointer;
            }

            .label_btn_submit {
                color: #ffffff;
                border: solid 1px #e64a19;
                background-color: #e64a19;
            }
        }
    }
}
</style>